import React from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useLanguage } from 'utils/useLanguage';

dayjs.extend(relativeTime);

interface TimeAgoProps {
    // sentTime is expected to be in UTC format
    sentTime: string;
}

const TimeAgo: React.FC<TimeAgoProps> = ({ sentTime }) => {
    const { language } = useLanguage();
    const timeAgo = dayjs(sentTime).locale(language).fromNow();

    return <span>{timeAgo}</span>;
};

export default TimeAgo;
